<div class="chart-container" [class.rtl]="!isEnglish" [class.ltr]="isEnglish">
  <ng-container *ngIf="loaded; else noDataLoaded">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between">
      <p class="start">{{ 'side_menu_reports.chart_header.per-hour' | translate }}</p>
    </div>
    <div class="chart">
      <div class="chart-wrapper">
        <canvas
          baseChart
          [dir]="!isEnglish ? 'rtl' : 'ltr'"
          [datasets]="lineChartData"
          [labels]="lineChartLabels"
          [options]="lineChartOptions"
          [colors]="lineChartColors"
          [legend]="lineChartLegend"
          [chartType]="lineChartType"
          [plugins]="lineChartPlugins"
        >
        </canvas>
        <p class="xLabel">{{ 'side_menu_reports.ton' | translate }}</p>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #noDataLoaded>
  <app-skeleton [type]="'dashboard'"></app-skeleton>
</ng-template>
